import React from "react"
import { WorkflowNode, WorkflowNodeData } from "lib/types/workflow"
import { useAppDispatch } from "lib/store"
import { hideEditSidebar } from "lib/store/services/editSidebar/slice"

import EditSidebar from "components/Ui/EditSidebar/EditSidebar"
import EditSideBarHeader from "components/Ui/EditSidebar/EditSidebarHeader"
import { DeleteNodeButton } from "./NodeEditorSidebar.styled"
import TriggerNodeForm from "./TriggerNodeForm"
import ConditionNodeForm from "./ConditionNodeForm"
import ActionNodeForm from "./ActionNodeForm"

type Props = {
  selectedNode: WorkflowNode | null
  onSave: (nodeId: string, data: WorkflowNodeData) => void
  onDelete: (nodeId: string) => void
}

const NodeEditorSidebar = ({ selectedNode, onSave, onDelete }: Props) => {
  const dispatch = useAppDispatch()

  if (!selectedNode) return null

  const nodeType = selectedNode.data.nodeType
  const title =
    nodeType === "TRIGGER"
      ? "Edit Trigger"
      : nodeType === "CONDITION"
        ? "Edit Condition"
        : "Edit Action"

  const handleClose = () => {
    dispatch(hideEditSidebar())
  }

  return (
    <EditSidebar cancelEvent={handleClose}>
      <EditSideBarHeader title={title} cancelEvent={handleClose}>
        {nodeType !== "TRIGGER" && (
          <DeleteNodeButton
            type="button"
            onClick={() => {
              onDelete(selectedNode.id)
              handleClose()
            }}
          >
            Delete Node
          </DeleteNodeButton>
        )}
      </EditSideBarHeader>
      {nodeType === "TRIGGER" && (
        <TriggerNodeForm node={selectedNode} onSave={onSave} />
      )}
      {nodeType === "CONDITION" && (
        <ConditionNodeForm node={selectedNode} onSave={onSave} />
      )}
      {nodeType === "ACTION" && (
        <ActionNodeForm node={selectedNode} onSave={onSave} />
      )}
    </EditSidebar>
  )
}

export default NodeEditorSidebar
